class LL_Dialog extends HTMLElement {
  constructor() {
    super();
    this.dialogElement = this.querySelector('.js_dialog');
    this.toggleButtons = this.querySelectorAll('.js_dialogToggle');
    this.videoElement = this.dialogElement.querySelector('video');

    this.dialogElement.addEventListener('click', event => {
      if (event.target === this.dialogElement) {
        this.toggleDialog();
      }
    });

    this.toggleButtons.forEach(button => {
      button.addEventListener('click', this.toggleDialog.bind(this));
    });
  }

  /**
   * Toggle dialog visibility based on its current state
   */
  toggleDialog() {
    if (this.isDialogOpen()) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }

  /**
   * Check if the dialog is currently open
   * @returns {Boolean} True if the dialog is open
   */
  isDialogOpen() {
    return this.dialogElement.hasAttribute('open');
  }


  /**
   * Open the dialog and add necessary event listeners
   */
  openDialog() {
    if (typeof this.dialogElement.showModal === "function") {
      this.dialogElement.showModal();
      if (this.videoElement) {
        this.videoElement.play();
      }
    } else {
      console.error('The <dialog> API is not supported by this browser');
    }
  }

    /**
   * Close the dialog and remove event listeners
   */
  closeDialog() {
    if (this.videoElement) {
      this.videoElement.pause();
      this.videoElement.currentTime = 0; // Reset the video to the start
    }
    this.dialogElement.close();
  }
}

customElements.define('ll-dialog', LL_Dialog);

{
  const checkbox = document.getElementById('js_gift');
  const app = document.querySelector('#main .shopify-section--apps');
  if (checkbox) {
    checkbox.addEventListener('change', function() {
      if (checkbox.checked) {
        app.classList.add('hidden');
        const closeBtn = document.querySelector('.delivery-select-container--close');
        if (closeBtn) {
          const event = new Event('click');
          closeBtn.dispatchEvent(event);
        }

        const select = document.querySelector('select.delivery-select-container__select');
        if (select) {
          setTimeout(() => {
            select.value = '指定なし';
          }, 1000);
        }
      } else {
        app.classList.remove('hidden');
      }
    }, false);
  }
}

{
  const alertBtn = document.getElementById('js_alert');
  if (alertBtn) {
    alertBtn.addEventListener('click', function() {
      alert('この商品はギフトラッピングと一緒に購入できません。');
    })
  }
}

{
  document.addEventListener('DOMContentLoaded', initializePress);
  function initializePress(){
    if (document.getElementById('js-pressSlider')) {
      new Swiper("#js-pressSlider",{slidesPerView:3.2,slidesPerGroup:3,spaceBetween:16,breakpoints:{768:{slidesPerView:5.8,slidesPerGroup:6,spaceBetween:32}},navigation:{prevEl:"#js-pressSlider .swiper-button-prev",nextEl:"#js-pressSlider .swiper-button-next"}})
    }
  }
}

// {
//   const giftModal = document.getElementById('js_giftModal');
//   const toggles = document.querySelectorAll('js_giftToggle');
//   toggles.forEach(toggle => {
//     toggle.addEventListener('click', function() {
//       giftModal.setAttribute('aria-hidden', !giftModal.getAttribute('aria-hidden'))
//     }, false);
//   });
// }